<nz-layout [class]="screenSize" [ngClass]="{'with-catalog-no-auth': !isLoggedIn}">
 
  <nz-header *isAuthorized  style="background: #263238 !important;" >
   
    <div class="logo">
      <a routerLink="/"><img [src]="'/assets/logo.svg'" alt="logo" /></a>
    </div>
    <div class="buttons">
      <nz-space>
    
        <!-- <nz-select [(ngModel)]="selectedLanguage" (ngModelChange)="changeLanguage($event)"
         class="language-select" style="width: 120px;">
          <nz-option nzValue="en" nzLabel="English"></nz-option>
          <nz-option nzValue="fr" nzLabel="French"></nz-option>
          <nz-option nzValue="es" nzLabel="Spanish"></nz-option>
          <nz-option nzValue="de" nzLabel="German"></nz-option>
        </nz-select> -->

        <ng-container *isAuthorized="'Admin'">
          <a *nzSpaceItem nz-button nzType="primary" nzShape="circle" [routerLink]="['/management']">
            <span>
              <i class="fal fa-cog"></i>
            </span>
          </a>
        </ng-container>
        <a *nzSpaceItem nz-button nzType="primary" nzShape="circle" [routerLink]="['/profile']">
          <span >
            <i class="fal fa-user-tie"></i>
          </span>
        </a>
        <button *nzSpaceItem nz-button nzType="primary" nzShape="circle"  (click)="logout()">
          <span>
            <i class="fal fa-sign-out-alt"></i>
          </span>
        </button>
      </nz-space>
    </div>
  </nz-header>
  <nz-layout>
    <nz-sider *isAuthorized nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" nzWidth="100px" style="position: relative">
      <app-navigation-sider [isCollapsed]="isCollapsed"></app-navigation-sider>
    </nz-sider>
    <nz-content [style]="{ 'max-width': innerWidth + 'px' }">
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
